import { render, staticRenderFns } from "./Paymeninfo.vue?vue&type=template&id=5897d6f0"
import script from "./Paymeninfo.vue?vue&type=script&lang=js"
export * from "./Paymeninfo.vue?vue&type=script&lang=js"
import style0 from "./Paymeninfo.vue?vue&type=style&index=0&id=5897d6f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports